import { render, staticRenderFns } from "./JuniorOrderForm.vue?vue&type=template&id=37981a40&scoped=true&"
import script from "./JuniorOrderForm.vue?vue&type=script&lang=js&"
export * from "./JuniorOrderForm.vue?vue&type=script&lang=js&"
import style0 from "./JuniorOrderForm.vue?vue&type=style&index=0&id=37981a40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37981a40",
  null
  
)

export default component.exports